import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import {PrismicRichText} from '@prismicio/react'
import type {LogoBarSliceLarge} from 'prismicio-types'
import {Container} from 'src/common/Container'
import {Gradient} from 'src/common/Gradient'

/**
 * Props for `LogoBar`.
 */
export type LogoBarDefaultProps = {
  slice: LogoBarSliceLarge & {
    slice_type: string
    variation: string
  }
}

/**
 * Component for "LogoBar" Slices.
 */
export const LogoBarLarge = ({slice}: LogoBarDefaultProps): JSX.Element => {
  const {items, primary} = slice

  return (
    <Container
      backgroundColor={primary.background_color || 'Dark Green'}
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="!py-10 px-5 md:!py-20 md:px-10 lg:px-5 xl:px-0"
    >
      <div className="flex w-full max-w-[1200px] scroll-mt-16 flex-col gap-6 md:gap-16" data-aos="fade-up">
        <div>
          {isFilled.richText(primary.heading) && (
            <PrismicRichText
              field={primary.heading}
              components={{
                heading2: ({children}) => (
                  <h2 className="md:text-tg-h2 text-center text-24 font-normal leading-[normal] text-moss-white">
                    {children}
                  </h2>
                ),
                strong: ({children}) => <span className="font-normal text-moss-white/[70%]">{children}</span>,
                em: () => <br className="max-md:hidden" />,
              }}
            />
          )}
        </div>
        <div className="relative flex h-15 select-none gap-4 overflow-hidden" data-aos-offset="0" data-aos="fade-left">
          <Gradient side="left" fromColor={primary.background_color || 'Beige/100'} />
          <Gradient side="right" fromColor={primary.background_color || 'Beige/100'} />
          <div className="flex shrink-0 animate-[slide_20s_linear_infinite] items-center justify-around md:gap-4">
            {items.map((item, i) => (
              <div className="grid place-items-center" key={i}>
                <PrismicNextImage field={item.logo} className="h-[55px] w-auto md:h-[80px]" />
              </div>
            ))}
          </div>
          <div
            className="flex shrink-0 animate-[slide_20s_linear_infinite] items-center justify-around md:gap-4"
            aria-hidden
          >
            {items.map((item, i) => (
              <div className="grid place-items-center" key={i}>
                <PrismicNextImage field={item.logo} className="h-[55px] w-auto md:h-[80px]" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  )
}
